import React from "react";
import "./Doctors.css";
import drImage from "../../assets/dr.jpeg";
import drdiksha from "../../assets/diskha2.jpg";
import drnidhi from "../../assets/NIdhi.jpg";
import navdeep from "../../assets/navdeep.jpg";
import { Link } from "react-router-dom";
const doctors = [
  {
    id: 1,
    name: "Dr. Harjeet Kaur",
    designation: "Senior IVF Specialist",
    image:
      drImage,
    description:
      "Experienced fertility specialist dedicated to providing advanced reproductive care with compassion and personalized treatment plans.",
  },
  {
    id: 2,
    name: "Dr. Nidhu Gupta",
    designation: "Consultant Gynecologist & IVF Expert",
    image:
      drnidhi,
    description:
      "Focused on women’s reproductive health and fertility management, ensuring every patient receives the best possible guidance and support.",
  },
  {
    id: 3,
    name: "Dr. Diksha",
    designation: "Fertility Consultant",
    image:
      drdiksha,
    description:
      "Committed to helping couples achieve parenthood through modern fertility treatments and patient-centered care.",
  },
 {
id: 4,
name: "Dt. Navdeep Kaur",
designation: "Dietician",
image: navdeep,
description: "Expert dietician crafting personalized nutrition plans for weight management, diabetes, PCOS, and heart health.Empowers patients with practical meal ideas and sustainable lifestyle changes for lasting results.Dedicated to compassionate, evidence-based care that transforms wellness journeys"
},
];

const Doctors = () => {
  return (
    <section className="doctors-section">
      <div className="container">
        <div className="section-header">
          <h2>Meet Our Experts</h2>
          <p>
            Our experienced fertility experts are dedicated to providing
            compassionate and advanced reproductive care.
          </p>
        </div>

        <div className="doctors-grid">
          {doctors.map((doctor) => (
            <div className="doctor-card" key={doctor.id}>
              <div className="doctor-image">
                <img src={doctor.image} alt={doctor.name} />
              </div>

              <div className="doctor-content">
                <h3>{doctor.name}</h3>
                <span>{doctor.designation}</span>
                <p>{doctor.description}</p>
                <Link
                    to="/bookappointment"
                    className="btn btn-appointment"
                    title="Book IVF Appointment"
                    
                  >
                    Book Appointment
                  </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Doctors;